import FlooringOverviewSubPage from "./flooring-owerview-sub-page";
import FlooringPriceVariationsSubPage from "./flooring-price-variations-sub-page";

const SubPage = {
  OverView: FlooringOverviewSubPage,
  PriceVariations: FlooringPriceVariationsSubPage,
};

export default SubPage;
